// extracted by mini-css-extract-plugin
module.exports = {"orderLink":"styles_orderLink__MynQY","orderItemTitle":"styles_orderItemTitle__4enJt","orderTimeLabel":"styles_orderTimeLabel__rTWNx"};